import { useTranslation } from 'react-i18next'

import { Minus, Package, Plus } from '@phosphor-icons/react'

import { Divider, IconButton, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ReturnLabelsSelector = ({ numberOfReturnLabels, deliveryMethod, maxNumberOfReturnLabels, onChange }) => {
  const { t } = useTranslation()
  const isMinusButtonDisabled = numberOfReturnLabels === 1
  const isPlusButtonDisabled = numberOfReturnLabels === maxNumberOfReturnLabels

  if (!deliveryMethod?.allows_multiple_return_labels || maxNumberOfReturnLabels === 1) return null

  return (
    <>
      <Divider />
      <Styles.Container>
        <Styles.Title type="titleS">
          <Package size={24} weight="thin" />
          {t('Etiquetas de envío')}
        </Styles.Title>
        <Styles.SectionContainer>
          <Text type="bodyMRegular">
            {t('Indica cuántas etiquetas de envío necesitas para tu devolución (una por cada paquete)')}
          </Text>
          <Styles.SelectorContainer>
            <Styles.NumberOfReturnLabelsContainer>
              <Text type="bodyMRegular">{t('Etiquetas de envío')}:</Text>
              <Text type="titleS">{numberOfReturnLabels}</Text>
            </Styles.NumberOfReturnLabelsContainer>
            <Styles.SelectorButtons>
              <IconButton
                onClick={() => onChange(numberOfReturnLabels - 1)}
                disabled={isMinusButtonDisabled}
                icon={<Minus size={24} />}
              />
              <IconButton
                onClick={() => onChange(numberOfReturnLabels + 1)}
                disabled={isPlusButtonDisabled}
                icon={<Plus size={24} />}
              />
            </Styles.SelectorButtons>
          </Styles.SelectorContainer>
        </Styles.SectionContainer>
      </Styles.Container>
    </>
  )
}

export default ReturnLabelsSelector
